import { fetchQnUptoken } from '@/service/api'

const state = {
  qnUptoken: null
}

const mutations = {
  getQnUptoken: (state, data) => {
    state.qnUptoken = data
  }
}

const actions = {
  getQnUptoken: async ({ commit }) => {
    try {
      const res = await fetchQnUptoken()
      commit('getQnUptoken', res)
    } catch (error) {
      console.log('error:', error)
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
